import { render, staticRenderFns } from "./WideSocialData.vue?vue&type=template&id=9ff4b208&scoped=true&"
import script from "./WideSocialData.vue?vue&type=script&lang=js&"
export * from "./WideSocialData.vue?vue&type=script&lang=js&"
import style0 from "./WideSocialData.vue?vue&type=style&index=0&id=9ff4b208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff4b208",
  null
  
)

export default component.exports